// extracted by mini-css-extract-plugin
module.exports = {"noDataCell":"Profitability_noDataCell__BavvD","filterInput":"Profitability_filterInput__3ycyE"};